<template>
  <div v-if="enabled">
    <apexchart
      type="area"
      height="400"
      :options="chartOptions"
      :series="series"
      v-if="measurementsData"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import MeasurementsFactory from "@/utils/measurementsfactory"
import temperatureUtils from "@/utils/temperature"

export default {
  name: "Temperatures",
  props: ["machine", "dates", "measurementsData"],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      enabled: false
    }
  },
  computed: {
    temperatureSymbol() {
      return temperatureUtils.getSymbol(this.units)
    },
    units() {
      return this.$store.getters.userDetails?.preferences?.units || "metric"
    },
    chartOptions() {
      return {
        chart: {
          fontFamily: "Roboto, sans-serif",
          height: 350,
          animations: {
            enabled: false
          },
          toolbar: {
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: false,
              zoomout: true,
              pan: false,
              reset: "<i class='v-icon mdi mdi-overscan'></i>"
            }
          }
        },
        theme: {
          palette: "palette6" // https://apexcharts.com/docs/options/theme/
        },
        noData: {
          text: this.$i18n.t("$vuetify.noDataText")
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "stepline",
          width: 4
        },
        title: {
          text: this.$t("machines.measurements.temperatures"),
          align: "left",
          floating: false
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: "datetime",
          // Add 24h prior to and 24h after the selected time range,
          // so that all data points are  properly displayed.
          min: new Date(this.dates[0]).getTime() - 24 * 3600 * 1000,
          max: new Date(this.dates[1]).getTime() + 24 * 3600 * 1000
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy HH:mm:ss"
          }
        },
        yaxis: {
          title: {
            text: `${this.$t("chart.legend.temperature")} (${
              this.temperatureSymbol
            })`
          },
          min: -20,
          max: max => {
            return max + 10
          }
        },
        legend: {
          showForSingleSeries: true,
          position: "top",
          horizontalAlign: "center",
          floating: this.$vuetify.breakpoint.mobile ? false : true,
          offsetY: this.$vuetify.breakpoint.mobile ? null : -25,
          offsetX: this.$vuetify.breakpoint.mobile ? null : -5
        }
      }
    },
    series() {
      let seriesConf = []
      seriesConf.push({
        name: this.$t("machines.measurements.hydraulicFluid"),
        parameterId: "M3",
        data: []
      })

      if (this.$store.getters.isService || this.$store.getters.isAdmin) {
        seriesConf.push({
          name: this.$t("machines.measurements.electricMotor"),
          parameterId: "M2",
          data: []
        })
      }

      if (this.isSmartPowerPlus) {
        seriesConf.push({
          name: this.$t("machines.measurements.ambient"),
          parameterId: "M150",
          data: []
        })
      }

      let temperatureSeries = MeasurementsFactory.makeAreaSeries(
        this.measurementsData,
        seriesConf,
        rawValue => {
          return Number(
            temperatureUtils.convertFromCelcius(rawValue, this.units)
          ).toFixed(0)
        }
      )
      return temperatureSeries
    },
    isSmartPowerPlus() {
      return this.machine.properties?.tags?.includes("smart_power_plus")
    }
  },
  mounted() {
    this.enabled = true
  },
  watch: {
    dates() {
      // Hack to fix issue with xaxis min max not updating on date change
      this.enabled = false
      setTimeout(() => {
        this.enabled = true
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped></style>
